var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "layout" },
    [
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-xs-12 col-md-4" }, [
          _c("div", { staticClass: "form-field" }, [
            _c(
              "label",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value:
                      _vm.tipoComprobante === "01" ||
                      _vm.tipoComprobante === "99",
                    expression:
                      "tipoComprobante === '01' || tipoComprobante === '99'"
                  }
                ],
                attrs: { for: "impagos" }
              },
              [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.form.impagos,
                      expression: "form.impagos"
                    }
                  ],
                  attrs: { type: "checkbox", id: "impagos" },
                  domProps: {
                    checked: Array.isArray(_vm.form.impagos)
                      ? _vm._i(_vm.form.impagos, null) > -1
                      : _vm.form.impagos
                  },
                  on: {
                    change: [
                      function($event) {
                        var $$a = _vm.form.impagos,
                          $$el = $event.target,
                          $$c = $$el.checked ? true : false
                        if (Array.isArray($$a)) {
                          var $$v = null,
                            $$i = _vm._i($$a, $$v)
                          if ($$el.checked) {
                            $$i < 0 &&
                              _vm.$set(_vm.form, "impagos", $$a.concat([$$v]))
                          } else {
                            $$i > -1 &&
                              _vm.$set(
                                _vm.form,
                                "impagos",
                                $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                              )
                          }
                        } else {
                          _vm.$set(_vm.form, "impagos", $$c)
                        }
                      },
                      function($event) {
                        return _vm.$refs.tablaComprobantes.loadRows()
                      }
                    ]
                  }
                }),
                _vm._v(" "),
                _c("span", [_vm._v("Ver comprobantes impagos")])
              ]
            )
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-xs-12 col-md-8" }, [
          _c("div", { staticClass: "form-field" }, [
            _c(
              "div",
              { staticClass: "form-group" },
              [
                _c(
                  "input-field",
                  {
                    attrs: {
                      readonly: "",
                      id: "filtroPersona",
                      placeholder: "Seleccione una persona..."
                    },
                    model: {
                      value: _vm.nombrePersona,
                      callback: function($$v) {
                        _vm.nombrePersona = $$v
                      },
                      expression: "nombrePersona"
                    }
                  },
                  [
                    _vm._v(
                      "\n                        Persona\n                    "
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.form.id_persona === "",
                        expression: "form.id_persona === ''"
                      }
                    ],
                    staticClass: "btn-info",
                    attrs: { type: "button" },
                    on: {
                      click: function($event) {
                        return _vm.$modal.show("consultaPersonas")
                      }
                    }
                  },
                  [_c("i", { staticClass: "fa fa-search" })]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.form.id_persona !== "",
                        expression: "form.id_persona !== ''"
                      }
                    ],
                    staticClass: "btn-danger",
                    attrs: { type: "button" },
                    on: { click: _vm.quitarPersona }
                  },
                  [_c("i", { staticClass: "fa fa-ban" })]
                )
              ],
              1
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c("k-table", {
        ref: "tablaComprobantes",
        attrs: {
          tipoComprobante: _vm.tipoComprobante,
          createButton: false,
          esComprobante: true,
          filterStatus: false,
          editButton: false,
          deleteButton: false,
          path: _vm.path,
          params: _vm.form,
          buttons: [
            {
              text: "",
              class: "btn-info",
              icon: "fa-eye",
              event: "ver"
            }
          ],
          columns: [
            {
              display: "Fecha de emisión",
              value: "fecha_emision"
            },
            {
              display: "N° establecimiento",
              value: "codigo_establecimiento"
            },
            {
              display: "N° emisor",
              value: "codigo_emisor"
            },
            {
              display: "N° Secuencial",
              value: "numero_secuencial"
            },
            {
              display: "Cliente",
              value: "nombre_cliente"
            },
            {
              display: "N° Identificación del cliente",
              value: "numero_identificacion"
            },
            {
              display: "Estado de pago",
              value: "descripcion_comprobante_pagado",
              hidden: _vm.tipoComprobante !== "01"
            },
            {
              display: "Total sin impuestos",
              value: "total_sin_impuestos",
              numeric: true,
              hidden: _vm.tipoComprobante === "07"
            },
            {
              display: "IVA",
              value: "valor_iva",
              numeric: true,
              hidden: _vm.tipoComprobante === "07"
            },
            {
              display: "ICE",
              value: "valor_ice",
              numeric: true,
              hidden: _vm.tipoComprobante === "07"
            },
            {
              display: "IRBPNR",
              value: "valor_irbpnr",
              numeric: true,
              hidden: _vm.tipoComprobante === "07"
            },
            {
              display: "Total",
              value: "valor_total",
              numeric: true
            },
            {
              display: "Estado",
              value: "estado"
            }
          ]
        },
        on: { ver: _vm.ver, seleccionar: _vm.seleccionar }
      }),
      _vm._v(" "),
      _c(
        "modal",
        {
          attrs: {
            width: "55%",
            height: "auto",
            name: "consultaPersonas",
            scrollable: ""
          }
        },
        [
          _c("lista-personas", {
            attrs: {
              createButton: false,
              tipoFiltro: _vm.tipoComprobante === "07" ? "P" : "C",
              filterStatus: false
            },
            on: { selected: _vm.selectedPersona }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "layout__header" }, [
      _c("h3", [_vm._v("Comprobantes")])
    ])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4a2fbae9", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4a2fbae9","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/comprobantes/ListaComprobantes.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-4a2fbae9","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/comprobantes/ListaComprobantes.vue
// module chunks = 0